import React from 'react';
import Navbar from './components/Navbar';
import './App.css';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import { Mobile } from "./components/mobile/mobile.component";
import { Laptop } from "./components/laptop/laptop.component";
import { TabletMobile } from "./components/tablet-mobile/tablet-mobile.component";

function App() {
  const isMobileDevice = useMediaQuery({
    query: "(max-device-width: 480px)",        
  });
  const isTabletDevice = useMediaQuery({
    query: "(min-device-width: 768px) and (max-device-width: 1000px)", 
  });
  const isLaptop = useMediaQuery({
    query: "(min-device-width: 1024px)",
  });


  return (
    <div className="App">
      {isMobileDevice && <Mobile />}
      {isTabletDevice && <TabletMobile />}
      {isLaptop && <Laptop />}
      {!isMobileDevice && !isTabletDevice && !isLaptop && <Laptop />}
    </div>
  );
}

export default App;
